import { OnChanges, SimpleChange } from '@angular/core';

/**
 * Returns true if the change is NOT the first-change and currentValue !== previousValue.
 */
export function isRealChange(change: SimpleChange): boolean {
  return change && !change.firstChange && change.currentValue !== change.previousValue;
}

/** Poor mans typed SimpleChange - until Angular provides something proper. */
export type SimpleChangeTyped<T, TPrev = T> = Omit<SimpleChange, 'currentValue' | 'previousValue'> & {
  currentValue: T;
  previousValue: TPrev;
};

/** Poor mans typed SimpleChanges - until Angular provides something proper. */
export type SimpleChangesTyped<TComponent extends OnChanges> = {
  [K in keyof TComponent as K extends `_${infer P}` ? never : TComponent[K] extends Function ? never : K]: SimpleChangeTyped<
    TComponent[K] extends infer T ? T : any
  >;
}; //              ^       ^  \                             /    \                                  /
//[All props of TComp ...but ^\exclude underscore prefixed/^ && ^\exclude props that are functions/^ ... and infer their type T but replace with SimpleChangeT<T> instead.
// If questions goto Nick :)
